// extracted by mini-css-extract-plugin
export default {"label":"LabelSingle_label__tpewR"};